import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const OtpModal = ({
  open,
  onClose,
  onSubmit,
  loading = false,
  error = "",
  onResendOtp,
  classes = {},
}) => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [resendTimer, setResendTimer] = useState(30);

  useEffect(() => {
    if (open) {
      setOtp(["", "", "", ""]);
      setResendTimer(30);
    }
  }, [open]);

  useEffect(() => {
    let timer;
    if (resendTimer > 0) {
      timer = setTimeout(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [resendTimer]);

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleSubmit = () => {
    const finalOtp = otp.join("");
    if (finalOtp.length === 4) {
      onSubmit(finalOtp);
    }
  };

  const handleResendClick = () => {
    if (resendTimer === 0 && typeof onResendOtp === "function") {
      onResendOtp(); // Call parent resend handler
      setResendTimer(30); // Reset the timer
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
       <DialogTitle>
        Enter OTP
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent style={{ textAlign: "center" }}>
        <Typography variant="body2" gutterBottom>
          Please enter the 4-digit OTP sent to your phone.
        </Typography>

        <Box display="flex" justifyContent="center" mb={2}>
          {otp.map((digit, index) => (
            <TextField
              key={index}
              id={`otp-input-${index}`}
              value={digit}
              onChange={(e) => handleChange(e.target.value, index)}
              inputProps={{
                maxLength: 1,
                style: {
                  textAlign: "center",
                  fontSize: "20px",
                  padding: "12px",
                },
              }}
              variant="outlined"
              size="small"
              style={{
                width: "50px",
                height: "50px",
                marginRight: index !== otp.length - 1 ? "10px" : "0",
              }}
            />
          ))}
        </Box>

        {error && (
          <Typography color="error" variant="caption">
            {error}
          </Typography>
        )}

        <Box mt={2}>
          <Button
            onClick={handleResendClick}
            disabled={resendTimer > 0}
            color="primary"
            className={classes.createButton}
          >
            {resendTimer > 0
              ? `Resend OTP in ${resendTimer}s`
              : "Resend OTP"}
          </Button>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleSubmit} className={`${classes.button2} ${classes.button}`} disabled={loading}>
          {loading ? "Verifying..." : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OtpModal;
